import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Send } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center bg-dark-900" data-id="element-120">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-dark-800 via-dark-900 to-black opacity-80 z-0" data-id="element-121"></div>

      {/* Gold Particles / Abstract Background */}
      <div className="absolute inset-0 opacity-20 z-0" data-id="element-122">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-500/20 rounded-full blur-[100px] animate-pulse" data-id="element-123"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-gold-600/20 rounded-full blur-[80px] animate-pulse delay-1000" data-id="element-124"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-126">
          <span className="inline-block py-1 px-3 border border-gold-500/30 rounded-full text-gold-500 text-xs tracking-[0.2em] uppercase mb-6 bg-gold-500/5 backdrop-blur-sm" data-id="element-127">
            Premium Companion Service
          </span>
          <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-128">
            邂逅优雅，
            <br className="md:hidden" data-id="element-129" />
            尽在 <span className="text-gradient-gold" data-id="element-130">IsYou</span>
          </h1>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light" data-id="element-131">
            新加坡领先的高端伴游服务平台，汇集全球优质伴游女郎。
            <br data-id="element-132" />
            真人核验，安全可靠，为您提供尊贵体验。
          </p>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-xl mx-auto" data-id="element-133">
          <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-8 rounded transition-all duration-300 text-base tracking-wide" data-id="element-134">
            <ExternalLink className="w-5 h-5" data-id="element-135" />
            进入官网 / Enter Website
          </a>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-3 border border-gold-500 text-gold-500 hover:bg-gold-500 hover:text-dark-900 font-bold py-4 px-8 rounded transition-all duration-300 text-base tracking-wide" data-id="element-136">
            <Send className="w-5 h-5" data-id="element-137" />
            电报频道 / Telegram Channel
          </a>
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-12 flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-gray-400" data-id="element-138">
          <div className="flex items-center" data-id="element-139">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-140"></span>
            500+ 优质伴游
          </div>
          <div className="flex items-center" data-id="element-141">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-142"></span>
            100% 真人核验
          </div>
          <div className="flex items-center" data-id="element-143">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-144"></span>
            24/7 在线客服
          </div>
          <div className="flex items-center" data-id="element-145">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-146"></span>
            见面满意付款
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center" data-id="element-147">
        <span className="text-[10px] text-gold-500 uppercase tracking-widest mb-2" data-id="element-148">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-gold-500 to-transparent" data-id="element-149"></div>
      </motion.div>
    </section>;
}